export enum AffiliateType {
  Single = 'single',
  Freelance = 'freelance',
  Company = 'company'
}
